import { render, staticRenderFns } from "./fileTag.vue?vue&type=template&id=02bb6e86&scoped=true&"
import script from "./fileTag.vue?vue&type=script&lang=ts&"
export * from "./fileTag.vue?vue&type=script&lang=ts&"
import style0 from "./fileTag.vue?vue&type=style&index=0&id=02bb6e86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb6e86",
  null
  
)

export default component.exports